export const ACTUALITY_CODE = '00';

export const SECTION_LENGTHS = {
	ACTUALITY_CODE: ACTUALITY_CODE.length,
	REGION: 2,
	DISTRICT: 3,
	CITY: 3,
	SETTLEMENT: 3,
	STREET: 4,
	HOUSE: 4,
};

export const ACCURACIES = {
	REGION:
		SECTION_LENGTHS.REGION,

	DISTRICT:
		SECTION_LENGTHS.REGION
	+	SECTION_LENGTHS.DISTRICT,

	CITY:
		SECTION_LENGTHS.REGION
	+ SECTION_LENGTHS.DISTRICT
	+ SECTION_LENGTHS.CITY,

	SETTLEMENT:
		SECTION_LENGTHS.REGION
	+ SECTION_LENGTHS.DISTRICT
	+ SECTION_LENGTHS.CITY
	+ SECTION_LENGTHS.SETTLEMENT,
				
	SETTLEMENT_WITH_ACTUALITY:
		SECTION_LENGTHS.REGION
	+ SECTION_LENGTHS.DISTRICT
	+ SECTION_LENGTHS.CITY
	+ SECTION_LENGTHS.SETTLEMENT
	+ SECTION_LENGTHS.ACTUALITY_CODE,

	STREET:
		SECTION_LENGTHS.REGION
	+ SECTION_LENGTHS.DISTRICT
	+ SECTION_LENGTHS.CITY
	+ SECTION_LENGTHS.SETTLEMENT
	+ SECTION_LENGTHS.STREET,

	STREET_WITH_ACTUALITY:
		SECTION_LENGTHS.REGION
	+ SECTION_LENGTHS.DISTRICT
	+ SECTION_LENGTHS.CITY
	+ SECTION_LENGTHS.SETTLEMENT
	+ SECTION_LENGTHS.STREET
	+ SECTION_LENGTHS.ACTUALITY_CODE,

	HOUSE:
		SECTION_LENGTHS.REGION
	+ SECTION_LENGTHS.DISTRICT
	+ SECTION_LENGTHS.CITY
	+ SECTION_LENGTHS.SETTLEMENT
	+ SECTION_LENGTHS.STREET
	+ SECTION_LENGTHS.HOUSE,
};